<h5 class="zint-card-title max-width-85">{{label}}</h5>
@if(!pubMethods.hasData(displayData)) {
  <div class="aira-nodata-icon-backdrop">
    <i class="fa-duotone fa-thin fa-chart-simple"></i>
    <p>No insights have been derived.</p>
  </div>
}
@else {
    <bar-chart [barChartData]="chartInput" [ngClass]="{'blur-content-strong': previewOnly}"></bar-chart>
  }
